import React from 'react';
import { FGLayout, FGFooter, FGGridContainer, FGGridItem, FGLink } from '@fg/design-system';
import { Header } from './Header';
import { DisclaimerFooter } from './DisclaimerFooter';

interface HeaderFooterProps {
  logoType: string;
  appCode: string;
  children: React.ReactNode;
  showDisclaimerFooter?: boolean;
  copyrightText?: string;
}

export const HeaderFooter: React.FC<HeaderFooterProps> = ({ 
  logoType, 
  appCode, 
  children, 
  showDisclaimerFooter,
  copyrightText = "Copyright © 2025 Fitch Solutions, Inc., Fitch Ratings, Inc., and their subsidiaries."

 }) => {
  return (
    <FGLayout
      header={<Header logoType={logoType} appCode={appCode} />}
      footer={
        <FGFooter>
            <>
                {showDisclaimerFooter && <DisclaimerFooter />}
                <FGGridContainer containerPadding={24} isFluid>
                    <FGGridItem xxs={12} xs={11} classNames="fg-as--fe">
                    <p className="fg-body3-long">
                      {copyrightText}
                    </p>
                    </FGGridItem>
                    <FGGridItem xxs={12} xs={1} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <p className="fg-body3-long">
                    <FGLink onClick={() => window.open('https://www.fitch.group/policies/')} appearance="blue">
                        Policies
                        </FGLink>
                    </p>
                    </FGGridItem>
                </FGGridContainer>
            </>
        </FGFooter>
      }
    >
      {children}
    </FGLayout>
  );
};
